import { render, staticRenderFns } from "./OrderTextCards.vue?vue&type=template&id=401bae79"
import script from "./OrderTextCards.vue?vue&type=script&lang=ts"
export * from "./OrderTextCards.vue?vue&type=script&lang=ts"
import style0 from "./OrderTextCards.vue?vue&type=style&index=0&id=401bae79&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports